import styled, { css } from 'styled-components'
import { desktopCSS, mobileCSS } from '@measures/responsive'
import SportsPartnerComponent, {
  SportsPartnerProps as SportsPartnerComponentProps,
} from '@components/SportsPartner'
import useClientViewportType from '@hooks/useClientViewportType'
import { FunctionComponent } from 'react'

export interface SportsPartnerProps {
  partner: SportsPartnerComponentProps['partner']
}

const StyledSportsPartner = styled(SportsPartnerComponent)`
  ${({
    theme: {
      measures: { outerPadding },
    },
  }) => css`
    ${desktopCSS(css`
      display: none;
    `)};

    ${mobileCSS(css`
      margin-left: -${outerPadding.mobile};
      margin-right: -${outerPadding.mobile};
      width: calc(100% + 2 * ${outerPadding.mobile});
    `)};
  `}
`

const SportsPartner: FunctionComponent<SportsPartnerProps> = ({ partner }) =>
  useClientViewportType() === 'desktop' ? null : (
    <StyledSportsPartner partner={partner} />
  )

export default SportsPartner
